<div class="faqs-page-nav-content">
  <a
    matRipple
    class="faqs-page-nav-item ods-typography-body-s-bold hoverable"
    *ngFor="let category of categories; let i = index"
    [matRippleColor]="'rgba(255, 134, 0, 0.2)'"
    [class.active]="i === activeIndex"
    (click)="onSelectCategory(i)"
  >
    <span class="faqs-page-nav-item-content">{{ category }}</span>
  </a>
</div>
